import React, { Component } from 'react'
import SVGInline from 'react-svg-inline'
import { Trans, withI18n, withI18nProps } from '@lingui/react'
import cn from 'classnames'

import Linka from 'client/shared/blocks/linka'
import TargetBlankIcon from 'client/shared/icons/target-blank.svg'
import Arrow from 'client/shared/icons/arrow-right.svg'
import Walker from 'client/shared/blocks/walker/walker'

import { NewsType, getNews } from './data/news'
import { PressItem, getPress } from './data/press'

import './news.styl'

type Props = {
  press?: PressItem[] | NewsType[]
  counter?: number
  moreButtonVisible?: boolean
  locale: string
} & withI18nProps

type State = { switcherMode: 'news' | 'press' }

class _News extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { switcherMode: 'press' }
  }

  showNews = (): void => this.setState({ switcherMode: 'news' })

  showPress = (): void => this.setState({ switcherMode: 'press' })

  getContent(locale: string): PressItem[] | NewsType[] {
    return this.state.switcherMode === 'news'
      ? getNews(locale)
      : getPress(locale)
  }

  render(): JSX.Element {
    const { locale, i18n } = this.props
    const { switcherMode } = this.state

    const content = this.getContent(locale)

    return (
      <div className="news">
        <div className="switcher">
          <div className="switcher__item-wrapper">
            <button
              aria-label={i18n.t`press.press`}
              className={cn('switcher__item', {
                'switcher__item-active': switcherMode === 'press',
              })}
              onClick={this.showPress}
            >
              <Trans id="press.press" />
            </button>
            &nbsp;/&nbsp;
          </div>
          <button
            aria-label={i18n.t`press.news`}
            className={cn('switcher__item', {
              'switcher__item-active': switcherMode === 'news',
            })}
            onClick={this.showNews}
          >
            <Trans id="press.news" />
          </button>
        </div>
        <Walker shouldShowLink>
          {content.map(item => {
            const { date, text, link, type } = item
            const path = link.startsWith('about')
              ? `${ASSETS_PATH}${link}`
              : link

            return (
              <div className="news__item">
                <div className="news__date">{date}</div>
                <p className="text">{text}</p>
                <Linka className="news__link" path={path} target="_blank">
                  <span>
                    <Trans id="press.read_more" />
                  </span>
                  &nbsp;&nbsp;
                  <SVGInline svg={type === 'news' ? Arrow : TargetBlankIcon} />
                </Linka>
              </div>
            )
          })}
        </Walker>
      </div>
    )
  }
}

export const News = withI18n({ update: true })(_News)
